import script from "./CustomCalendarDate.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCalendarDate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__